export type TicketResponse = {
  message: string;
  ticketId?: string;
};

export enum TicketType {
  MAGGIE = 'MAGGIE',
  GRANT = 'GRANT',
  INSUFFICIENT_GRANT_CREDITS = 'INSUFFICIENT_GRANT_CREDITS',
}

export type TicketRequest = {
  organizationId: string;
  ticketType: TicketType;
};
